import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';

export const IvStatusSkeleton: FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', height: '40px', marginTop: '10px' }}>
      <Box sx={{ display: 'flex' }}>
        <Skeleton variant="circular" sx={{ width: '18px', height: '18px', margin: '4px 5px 0 5px' }} />
      </Box>
      <Box>
        <Skeleton variant="text" sx={{ height: '18px', width: '130px' }} />
        <Skeleton variant="text" sx={{ height: '18px', width: '110px' }} />
      </Box>
    </Box>
  );
};
